import { withUnmountTransition } from '../../../../../misc/withUnmountTransition.hoc'
import { DoctolibPatientInfoUpdateModal } from './DoctolibPatientInfoUpdateModal.component'

const withUnmountHoc = withUnmountTransition(DoctolibPatientInfoUpdateModal)
export { withUnmountHoc as DoctolibPatientInfoUpdateModal }
